import { observable, action, computed } from 'mobx'

export default class ImageChoicesChallenge {
  @observable selectedChoice = null
  @observable choices = []

  constructor ({ challenge }) {
    const { image_choices, ...rest } = challenge
    Object.assign(this, {
      choices: image_choices,
      ...rest
    })
  }

  @action setAnswer (answer) {
    this.selectedChoice = answer
  }

  @computed get answer () {
    // The answer must be the index of the selected value
    const choice = this.selectedChoice
    if (!choice) {
      return null
    }

    return this.choices.indexOf(choice)
  }
}



// WEBPACK FOOTER //
// ./src/client/components/LinkAccountDialog/QuovoProvider/MultiFactorAuth/ImageChoicesChallenge/Challenge.js